import React from 'react';
// import { Typography } from '@mui/material';
// import * as Icon from 'react-bootstrap-icons';
import { useState } from 'react';

function LocAnswerFooter({ list1, list2 }) {
  const [isShown, setIsShown] = useState(false);

  function showDiv() {
    setIsShown(!isShown);
  }
  return (
    <div style={{ marginBottom: '15px', width: '90%' }}>
      <div>
        <h6 style={{ marginTop: '10px' }}>
          {/* <button className="btn btn-link"> */}
          {/* {isShown ? <Icon.CaretUpFill /> : <Icon.CaretDownFill />} */}
          {/* </button> */}
          Click for Answers to the parking facility questions
        </h6>
      </div>
      <div
        id="questsDiv2"
        onClick={() => {
          showDiv();
          console.log('Open Div');
        }}
      >
        {list1}
      </div>
      <br />
      <br />
    </div>
  );
}

export default LocAnswerFooter;
